import { useLayoutEffect, useMemo, useState } from 'react'

interface UseDimensionsReturn {
  isDesktop: boolean
  isMobile: boolean
  isTablet: boolean
}

export default function useDimensions (): UseDimensionsReturn {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  const isDesktop = useMemo(() => windowWidth >= 912, [windowWidth])
  const isMobile = useMemo(() => windowWidth <= 568, [windowWidth])
  const isTablet = useMemo(() => windowWidth > 568 && windowWidth < 912, [windowWidth])

  useLayoutEffect(() => {
    const handleResize = (): void => { setWindowWidth(window.innerWidth) }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return { isDesktop, isMobile, isTablet }
}
